import { autobind } from 'core-decorators'
import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { Component } from 'react'
import PowerGlove from 'shared/containers/power-glove'
import flagGif from '../../redux/flag'
import ReportModal from './report-form'

class Flag extends Component {
    static propTypes = {
        gifID: PropTypes.string.isRequired,
        csrftoken: PropTypes.string.isRequired,
        user: PropTypes.object.isRequired,
        hideCancel: PropTypes.bool,
        isFlagged: PropTypes.bool,
        isActive: PropTypes.bool,
        showButton: PropTypes.bool,
        togglePowerGlove: PropTypes.func,
        onFormToggle: PropTypes.func,
        isClip: PropTypes.bool,
    }

    state = {
        isInvalid: false,
        isActive: this.props.isActive || false,
        isFlagged: this.props.isFlagged || false,
    }

    @autobind
    toggleForm() {
        const { isFlagged, isActive } = this.state
        const { togglePowerGlove, onFormToggle = () => {} } = this.props

        if (isFlagged) {
            return
        }

        togglePowerGlove && togglePowerGlove()
        this.setState({ isActive: !isActive, isInvalid: false })
        onFormToggle(!isActive)
    }

    @autobind
    setIsFlagged(isFlagged) {
        this.setState({ isFlagged })
    }

    @autobind
    onSubmit(form) {
        const { gifID, user } = this.props

        if (!form.checkValidity()) {
            this.setState({ isInvalid: true })
            return
        }

        this.toggleForm()
        const data = new FormData(form)
        data.append('username', user.username)
        return flagGif(gifID, user, data).then((isSucessful) => this.setIsFlagged(isSucessful))
    }

    componentDidUpdate() {
        const { isActive } = this.state

        if (isActive && this.formComponent) {
            this.formComponent.getForm().scrollIntoView()
        }
    }

    render() {
        const { hideCancel, Modal, isClip } = this.props
        const { isActive, isInvalid } = this.state
        const FlagForm = () => (
            <ReportModal
                ref={(component) => (this.formComponent = component)}
                onSubmit={this.onSubmit}
                toggleForm={this.toggleForm}
                isActive={isActive}
                isInvalid={isInvalid}
                hideCancel={hideCancel}
                isClip={isClip}
                gif={this.props.gifID}
            />
        )

        return (
            <div>
                {Modal ? (
                    isActive ? (
                        <FlagForm />
                    ) : null
                ) : (
                    <PowerGlove onCancel={this.toggleForm}>
                        <FlagForm />
                    </PowerGlove>
                )}
            </div>
        )
    }
}

export default Flag
